import { Spin } from "antd";

const Loading = ()=>(
    <Spin size="small" className="custom-spin" /> 
)
export default Loading;